export function responsiveBindingSmallDevices(setterMethod) {
  responsiveBinding('1024px', setterMethod);
}
export function responsiveBindingMobile(setterMethod) {
  responsiveBinding('768px', setterMethod);
}
export function responsiveBinding(witdh, setterMethod) {
  const mql = window.matchMedia(`(max-width: ${witdh})`);
  setterMethod(mql.matches);
  mql.onchange = event => {
    setterMethod(event.matches);
  };
}